export interface IMedicalTest {
    id: number;
    categoryName: string;
    name: string;
    min: number;
    max: number;
    unit: string;
}
